"use client";

import { useEffect } from "react";

export const SERVER_CONTENT_META = "calmlens-server-content";

export const markHydrated = () => {
  document.documentElement.dataset.hydrated = "true";
};

/** The root's part: marks the document hydrated, unless server component content is still to. */
export const useDocumentHydrated = () => {
  useEffect(() => {
    if (!document.querySelector(`meta[name="${SERVER_CONTENT_META}"]`)) markHydrated();
  }, []);
};
